import { render, staticRenderFns } from "./org-message-templates.vue?vue&type=template&id=1a91b2cc&scoped=true&"
import script from "./org-message-templates.vue?vue&type=script&lang=js&"
export * from "./org-message-templates.vue?vue&type=script&lang=js&"
import style0 from "./org-message-templates.vue?vue&type=style&index=0&id=1a91b2cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a91b2cc",
  null
  
)

export default component.exports